import React from "react";
import "./HeaderHomepage.css";
import { useHistory } from "react-router-dom";

const HeaderHomepage = () => {
  let history = useHistory();

  const logInClicked = () => {
    history.push("/login");
  };

  const signUpClicked = () => {
    history.push("/signup");
  };

  const homeClicked = () => {
    history.push("/");
  };

  const contactUsClicked = () => {
    history.push("/contactus");
  };

  const qaClicked = () => {
    history.push("/qa");
  };

  const tellAboutUsClicked = () => {
    history.push("/tellaboutus");
  };

  const intoSiteClicked = () => {
    history.push("/intosite");
  };

  const findplaceClicked = () => {
    history.push("/findplace");
  };

  const howItWorkClicked = () => {
    history.push("/howitwork");
  };

  const humburgerClicked = () => {
    const slidePanel = document.getElementById("slidepanel");

    if (!slidePanel) return;

    if (slidePanel.style.width === "200px") {
      slidePanel.style.width = "0px";
    } else {
      slidePanel.style.width = "200px";
    }
  };

  return (
    <div className="headerHomepage-wrapper">
      <div className="headerHomepage">
        <div className="hp-logo" onClick={homeClicked}></div>

        <div className="homepage-header-actions">
          <div className="button-header shadow" onClick={signUpClicked}>
            הרשמה
          </div>
          <div className="button-header shadow" onClick={logInClicked}>
            כניסה
          </div>
        </div>

        <nav className="homepage-desktop-nav">
          <button type="button" onClick={howItWorkClicked}>
            איך דאבל עובד?
          </button>

          <button type="button" onClick={intoSiteClicked}>
            הצצה לאתר
          </button>

          <button type="button" onClick={tellAboutUsClicked}>
            כותבים לנו
          </button>

          <button type="button" onClick={findplaceClicked}>
            מקומות לדייטים
          </button>

          <button type="button" onClick={qaClicked}>
            שאלות ותשובות
          </button>
        </nav>

        <div className="homepage-bsd">בס"ד</div>

        <div
          className="hamburger"
          onClick={humburgerClicked}
          aria-label="פתיחת תפריט"
        ></div>

        <div id="slidepanel">
          <div className="slidepanel-close" onClick={humburgerClicked}>
            X
          </div>

          <div className="button-slidepanel" onClick={howItWorkClicked}>
            איך דאבל עובד?
          </div>

          <div className="button-slidepanel" onClick={intoSiteClicked}>
            הצצה לאתר
          </div>

          <div className="button-slidepanel" onClick={tellAboutUsClicked}>
            כותבים לנו
          </div>

          <div className="button-slidepanel" onClick={findplaceClicked}>
            מקומות לדייטים
          </div>

          <div className="button-slidepanel" onClick={qaClicked}>
            שאלות ותשובות
          </div>

          <div className="button-slidepanel" onClick={contactUsClicked}>
            יצירת קשר
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderHomepage;

// import React from "react";
// import "./HeaderHomepage.css";
// import { useHistory } from "react-router-dom";

// const HeaderHomepage = () => {
//   let history = useHistory();

//   const logInClicked = async () => {
//     history.push("/login");
//   };

//   const signUpClicked = () => {
//     history.push("/signup");
//   };

//   const homeClicked = () => {
//     if (window.location.href.includes("sign")) {
//       history.push("/");
//     } else {
//       humburgerClicked();
//     }
//   };

//   const contactUsClicked = () => {
//     history.push("/contactus");
//   };

//   const qaClicked = () => {
//     history.push("/qa");
//   };

//   const tellAboutUsClicked = () => {
//     history.push("/tellaboutus");
//   };

//   const intoSiteClicked = () => {
//     history.push("/intosite");
//   };

//   const findplaceClicked = () => {
//     history.push("/findplace");
//   };

//   const howItWorkClicked = () => {
//     history.push("/howitwork");
//   };

//   const humburgerClicked = () => {
//     if (document.getElementById("slidepanel").style.width === "200px") {
//       document.getElementById("slidepanel").style.width = "0px";
//     } else {
//       document.getElementById("slidepanel").style.width = "200px";
//     }
//   };
//   return (
//     <div>
//       <div className="headerHomepage">
//         {/* <div className="phone"></div> */}

//         <div className="hp-logo" onClick={homeClicked} />
//         <div className="button-header shadow" onClick={signUpClicked}>
//           הרשמה
//         </div>

//         <div className="button-header shadow" onClick={logInClicked}>
//           כניסה
//         </div>
//         <div className="lbl">בס"ד</div>
//         {/* <div className="running"> אנחנו בהרצה, תהיו סבלניים :)</div> */}

//         <div className="hamburger" onClick={humburgerClicked}></div>
//         <div id="slidepanel">
//           <div className="slidepanel-close" onClick={humburgerClicked}>
//             X
//           </div>

//           <div className="button-slidepanel" onClick={howItWorkClicked}>
//             איך דאבל עובד?
//           </div>
//           <div className="button-slidepanel" onClick={intoSiteClicked}>
//             הצצה לאתר
//           </div>
//           <div className="button-slidepanel" onClick={tellAboutUsClicked}>
//             כותבים לנו
//           </div>
//           <div className="button-slidepanel" onClick={findplaceClicked}>
//             מקומות לדייטים
//           </div>
//           <div className="button-slidepanel" onClick={qaClicked}>
//             שאלות ותשובות
//           </div>
//           <div className="button-slidepanel" onClick={contactUsClicked}>
//             יצירת קשר
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HeaderHomepage;
